import * as yup from "yup";

export const agreementFieldNames = {
  CONSENT_DATA_VERIFICATION: "consentDataVerification",
  CONSENT_DATA_VERIFICATION_LEPL: "consentDataVerificationLepl",
  CONSENT_DATA_INCOME_REMITTANCE: "consentDataIncomeRemittance",
  CONSENT_DATA_FUTURE_OFFERS: "consentDataFutureOffers",
};

export const LOAN_AGREEMENT_CONSENTS = [
  {
    name: agreementFieldNames.CONSENT_DATA_FUTURE_OFFERS,
    translationKey: "loan_future_offers_consent",
    required: false,
  },
  {
    name: agreementFieldNames.CONSENT_DATA_VERIFICATION_LEPL,
    translationKey: "loan_revenue_service_consent",
    required: true,
  },
  {
    name: agreementFieldNames.CONSENT_DATA_VERIFICATION,
    translationKey: "loan_credit_bureau_consent",
    required: true,
  },
  {
    name: agreementFieldNames.CONSENT_DATA_INCOME_REMITTANCE,
    translationKey: "loan_remittance_income_consent",
    required: true,
  },
];

export function getLoanAgreementValidationSchema(requiredMessage) {
  return yup.object().shape(
    Object.fromEntries(
      LOAN_AGREEMENT_CONSENTS.map(({ name, required }) => [
        name,
        required
          ? yup.boolean().isTrue(requiredMessage).required(requiredMessage)
          : yup.boolean(),
      ]),
    ),
  );
}
